import { Component, OnInit, ViewEncapsulation,ViewChild,Input, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalService } from '../global.service';
import * as M from "materialize-css/dist/js/materialize";

@Component({
	selector: 'unos-izmjena-broj-mjesta',
	templateUrl: './unos-izmjena-broj-mjesta.component.html',
	styleUrls: ['./unos-izmjena-broj-mjesta.component.css']
})
export class UnosIzmjenaBrojMjestaComponent implements OnInit {

	@Output() onInsertFakultet = new EventEmitter<any>();
	@Output() onCancel = new EventEmitter<any>();

	constructor(private http: HttpClient, public globalSrvc: GlobalService) { }
	rokovi : any = [];
	loading = false;
	msg : any;

	ngOnInit() {
		this.ucitaj();
	}

	server_data : any = null;

	ucitaj(){
		this.loading = true;
		this.http.get(this.globalSrvc.rootUrl +'prijave/rokovi/brojmjesta/')
		.subscribe(data => {
			this.loading = false;
			this.server_data = data;			
            //console.log("uspjeh", this.uspjeh);
			this.rokovi = this.server_data.rokovi;			
		}
		,error => {
			this.loading = false;
		});
	}

	toastTimeout = 5000;

	cancel(){
		if (this.onCancel)
			this.onCancel.emit(null);
	}

	savedata(){
		console.log(this.rokovi);

		if(!this.rokovi)
			return; 

		for(let i = 0; i < this.rokovi.length; i++){
			let rok = this.rokovi[i];

			if (rok.brRokI && !this.globalSrvc.CheckInt(rok.brRokI)){
				let err = 'Za studijski program ' + rok.naziv + ' nevalidan format za polje Broj mjesta I rok. Unesite cio broj!';
				M.toast({html: err, displayLength : this.toastTimeout});
				return;
			}

			if (rok.brRokII && !this.globalSrvc.CheckInt(rok.brRokII)){
				let err = 'Za studijski program ' + rok.naziv + ' nevalidan format za polje Broj mjesta II rok. Unesite cio broj!';
				M.toast({html: err, displayLength : this.toastTimeout});
				return;
			}

			if (rok.brRokIII && !this.globalSrvc.CheckInt(rok.brRokIII)){
				let err = 'Za studijski program ' + rok.naziv + ' nevalidan format za polje Broj mjesta III rok. Unesite cio broj!';
				M.toast({html: err, displayLength : this.toastTimeout});
				return;
			}

			if (rok.brRokIV && !this.globalSrvc.CheckInt(rok.brRokIV)){
				let err = 'Za studijski program ' + rok.naziv + ' nevalidan format za polje Broj mjesta IV rok. Unesite cio broj!';
				M.toast({html: err, displayLength : this.toastTimeout});
				return;
			}
		}

		let obj = {rokovi : this.rokovi};

		let url = 'prijave/rokovi/brojmjesta/izmjena';

		this.loading = true;
		
		setTimeout(() => {				
		
			this.http.post(url, obj)
				.subscribe(data => {
					this.msg = data;
					this.loading = false;

					if (this.msg.id == 1) {
						if (this.onInsertFakultet)
							this.onInsertFakultet.emit(obj);
					}
					else {
						//this.globalSrvc.showErrorModal(this.msg.text);
						M.toast({html:this.msg.text, displayLength : this.toastTimeout});
					}
				}
				, error => {
					this.loading = false;
					//this.globalSrvc.showGenericErrorModal();
				}
			);
		}, 1000);
	}
}
